<template>
    <Summary :ServiceID="AppServiceID"></Summary>
</template>
<script>
import Summary from '@/components/Common/PatientSummary.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID:''
        }
    },
 components: {
    Summary  : Summary 
        },
   created: function() {
      this.$emit('update:layout', LayoutDefault);
      this.AppServiceID = this.$store.getters.GetHearingID;
    },
    beforeCreate: function() { 
        this.$store.dispatch('AddServiceID',this.$store.getters.GetHearingID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetHearingID); 
    },
}
</script>
